"use strict";

document.querySelector(".hamburger-Menu").addEventListener("click", (event) => {
  event.target.classList.toggle("active");
  document.querySelector(".mobile-menu").classList.toggle("active");
});